import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const PlaceholderIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="3.5" stroke="#111112" />
    </svg>
  );
};

export { PlaceholderIcon };
